var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChooseAmzSpu',{attrs:{"visible":_vm.visible,"reserve":true,"amzSpuStatusList":['Y'],"title":_vm.title,"multiple":_vm.multiple},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.spuConfirm,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }